export default __webpack_public_path__ + "77ae471070b295ad68b8ef955b72c604.png";